import { render, staticRenderFns } from "./AdminProduct.vue?vue&type=template&id=4c10f38f&scoped=true&"
import script from "./AdminProduct.vue?vue&type=script&lang=js&"
export * from "./AdminProduct.vue?vue&type=script&lang=js&"
import style0 from "./AdminProduct.vue?vue&type=style&index=0&id=4c10f38f&prod&lang=css&"
import style1 from "./AdminProduct.vue?vue&type=style&index=1&id=4c10f38f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c10f38f",
  null
  
)

export default component.exports